<template>
  <div class="careers-page">
    <div class="careers-page__content">
      <div class="container">
        <ScreenHeader class="careers-page__header" data-aos="fade-down">
          <template #subtitle>{{
            pageContent.jobsScreen.subtitle || CAREERS_SCREEN_DEFAULTS.subtitle
          }}</template>
          <template #title>{{
            pageContent.jobsScreen.title || CAREERS_SCREEN_DEFAULTS.title
          }}</template>
          <template #text>
            {{
              pageContent.jobsScreen.description ||
              CAREERS_SCREEN_DEFAULTS.description
            }}
          </template>
        </ScreenHeader>
      </div>
      <JobsCatalog
        class="careers-page__jobs-catalog container"
        :jobs="pageContent.jobsScreen.jobs"
      />
      <AboutTeamScreen
        :header-title="pageContent.aboutTeamScreen.title"
        :header-subtitle="pageContent.aboutTeamScreen.subtitle"
        :content="pageContent.aboutTeamScreen.text"
      />
      <JobBenefitsScreen
        v-if="pageContent.benefitsScreen.benefits.length > 0"
        class="careers-page__benefits"
        :title="pageContent.benefitsScreen.title"
        :subtitle="pageContent.benefitsScreen.subtitle"
        :description="pageContent.benefitsScreen.description"
        :benefits="pageContent.benefitsScreen.benefits"
        :background-uri="pageContent.benefitsScreen.backgroundUri"
      />
      <TeamValuesScreen
        v-if="pageContent.teamValuesScreen.values.length > 0"
        :header-title="pageContent.teamValuesScreen.title"
        :header-subtitle="pageContent.teamValuesScreen.subtitle"
        :header-text="pageContent.teamValuesScreen.description"
        :values="pageContent.teamValuesScreen.values"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import AboutTeamScreen from "@/layers/website/components/page-screens/AboutTeamScreen.vue";
  import JobBenefitsScreen from "@/layers/website/components/page-screens/JobBenefitsScreen.vue";
  import TeamValuesScreen from "@/layers/website/components/page-screens/TeamValuesScreen.vue";

  const CAREERS_SCREEN_DEFAULTS = {
    title: "We’re hiring!",
    subtitle: "Join Us",
    description:
      "The best is yet to come. Great games are made by great teams. Want to be part of one?",
  };

  const { getAllJobs, getCurrentPageSettings } = useWebsiteContent();
  const { data: jobs, suspense: jobsSuspense } = getAllJobs();
  const { data: pageSettings, suspense: pageSettingsSuspense } =
    getCurrentPageSettings();

  const pageContent = computed(() => ({
    jobsScreen: {
      title: pageSettings.value.additional?.jobsScreen?.title,
      subtitle: pageSettings.value.additional?.jobsScreen?.subtitle,
      description: pageSettings.value.additional?.jobsScreen?.description,
      jobs: jobs.value ?? [],
    },
    aboutTeamScreen: {
      title: pageSettings.value.additional?.aboutTeamScreen?.title,
      subtitle: pageSettings.value.additional?.aboutTeamScreen?.subtitle,
      text: pageSettings.value.additional?.aboutTeamScreen?.description,
    },
    benefitsScreen: {
      title: pageSettings.value.additional?.benefitsScreen?.title,
      subtitle: pageSettings.value.additional?.benefitsScreen?.subtitle,
      description: pageSettings.value.additional?.benefitsScreen?.description,
      benefits: pageSettings.value.additional?.benefitsScreen?.benefits ?? [],
      backgroundUri: pageSettings.value.additional?.benefitsScreen?.backgroundUri,
    },
    teamValuesScreen: {
      title: pageSettings.value.additional?.teamValuesScreen?.title,
      subtitle: pageSettings.value.additional?.teamValuesScreen?.subtitle,
      description: pageSettings.value.additional?.teamValuesScreen?.description,
      values: pageSettings.value.additional?.teamValuesScreen?.teamValues ?? [],
    },
  }));

  definePageMeta({
    settings: {
      cover: {
        title: "Careers",
      },
    },
  });

  await Promise.all([
    jobsSuspense(),
    pageSettingsSuspense(),
  ]);
</script>

<style lang="scss">
  .careers-page {
    &__content {
      display: flex;
      flex-direction: column;
      gap: 32px;

      padding: 64px 0 0;
    }

    &__header {
      max-width: 512px;

      margin: 0 auto;
    }

    &__jobs-catalog {
      position: relative;
      z-index: 1;
    }

    // &__benefits {
    //   @media (max-width: $md) {
    //     order: 1;
    //   }
    // }
  }
</style>
